// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createSubscriber, createContainer } from '@atlassian/react-sweet-state';
import Store from './store.tsx';

export const FavoriteAPISubscriber = createSubscriber(Store, {
	displayName: 'FavoriteAPISubscriber',
	selector: null,
});

export const FavoriteAPIContainer = createContainer(Store);

export type FavouriteAPISubscriberType = typeof FavoriteAPISubscriber;
